import { ReactNotifications } from "../../Functionalities/notifications";

export const Alerts = () => {
  return (
    <div className="app-container">
      <ReactNotifications />
    </div>
  );
};
